import { render, staticRenderFns } from "./BarB.vue?vue&type=template&id=62da6d92&"
import script from "./BarB.vue?vue&type=script&lang=js&"
export * from "./BarB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports